module.exports = __webpack_public_path__ + "files/4dfd26c79ff4a420b6336ab1e7ad64e3.svg";